import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Firestore, collectionData, collection, addDoc, getDocs, query, where } from '@angular/fire/firestore';
import { of } from 'rxjs';
import { UserService } from '../user/user.service';

declare let Email: any;

@Injectable(
    {
        providedIn: 'root'
    }
)
export class EmailServiceComponent {

    constructor(public userService:UserService,public http: HttpClient, public firestore: Firestore) { }


    /**
     * 
     * @param user 
     */
    sendEmail(users): Promise<any> {

        

        // const body = `<p><em>Bonjour ${user.firstname},</em></p>
        // <p><em>Nous te souhaitons la bienvenue à Eulogia</em></p>
        // <p><em>Ton inscription a bien &eacute;t&eacute; prise en compte, t</em><em>u recevras par mail un mot de passe temporaire (que tu devras changer) avec ton login (ton email) pour acc&eacute;der &agrave; ton <a href="https://www.eulogia-enseignement.fr/login">espace</a> Etudiant.</em></p>
        // <p><em>Merci de nous faire confiance.</em></p>
        // <p><em>Pour toute information compl&eacute;mentaire n&rsquo;h&eacute;site pas &agrave; nous contacter au&nbsp;: <a href="tel:+33695340678">+33 6 95 34 06 78</a> ou par mail au <u><a href="mailto:contact@eulogia-enseignement.fr">contact@eulogia-enseignement.fr</a></u></em> &nbsp;</p>
        // <p><em>A bient&ocirc;t </em></p>
        // <p><em>L&rsquo;&eacute;quipe p&eacute;dagogique Eulogia</em></p>`;

        //return this.email(`Eulogia - validation de ton inscription`, body, user.email);
        this.sendpass();
        return Promise.allSettled(users.map(user => this.sendMessageToUser(user)));
//   .then((results) => {
//     console.log('Tous les messages ont été traités (succès ou échec) :');
//     results.forEach((result, index) => {
//       if (result.status === 'fulfilled') {
//         console.log(`✅ ${users[index]}: ${result.value}`);
//       } else {
//         console.log(`❌ ${users[index]}: ${result.reason}`);
//       }
//     });
//   },(error)=>console.log(error));
//         return new Promise(null);

    }

    sendMessageToUser(user) {
        // return new Promise((resolve, reject) => {
        //   setTimeout(() => {
        //     if (user === 'Gnakry') {
        //       reject(`Échec pour ${user}`);
        //     } else {
        //       resolve(`Message envoyé à ${user}`);
        //     }
        //   }, 1000);
        // });
console.log("-----------")
        console.log(user)

        const body = `<p><em>Bonjour ${user.firstname},</em></p>
        <p><em>Nous te souhaitons la bienvenue à Eulogia</em></p>
        <p><em>Ton inscription a bien &eacute;t&eacute; prise en compte, t</em><em>u recevras par mail un mot de passe temporaire (que tu devras changer) avec ton login (ton email) pour acc&eacute;der &agrave; ton <a href="https://www.eulogia-enseignement.fr/login">espace</a> Etudiant.</em></p>
        <p><em>Merci de nous faire confiance.</em></p>
        <p><em>Pour toute information compl&eacute;mentaire n&rsquo;h&eacute;site pas &agrave; nous contacter au&nbsp;: <a href="tel:+33695340678">+33 6 95 34 06 78</a> ou par mail au <u><a href="mailto:contact@eulogia-enseignement.fr">contact@eulogia-enseignement.fr</a></u></em> &nbsp;</p>
        <p><em>A bient&ocirc;t </em></p>
        <p><em>L&rsquo;&eacute;quipe p&eacute;dagogique Eulogia</em></p>`;
        //this.userService.update(user);
       // this.userService.saveUser(user)

       // return this.email(`Eulogia - validation de ton inscription`, body, user.email);
      }

    sendpass()
    { 
        
        let person1:{email:string, password:string}[] = [
               {email:"mvouyorick@gmail.com",password:"yjzK0B"}
        //    ,{email:"abandadjohwilliam@gmail.com",password:"4ut18T"}
        //     ,{email:"d.maximilien@gmail.com",password:"nE5fNc"}
        //     ,{email:"eloundoupatricia@yahoo.fr",password:"xK4EKG"}
        //     ,{email:"fabrice.fehem@gmail.com",password:"1drlct"}
        //     ,{email:"fedjour@gmail.com",password:"NkJh44"}
        //     ,{email:"florent.zobel@gmail.com",password:"I4I9xh"}
        //     ,{email:"loreta.atomreprat@gmail.com",password:"0Ur8s2"}
        //     ,{email:"marina.djedouboum@gmail.com",password:"RYJLqX"}
            // ,{email:"mvouyorick@gmail.com",password:"uWqLZi"}
            // ,{email:"thierry.pandzou@gmail.com",password:"aKljJE"}
            ];
         let person:{email:string, password:string}[] = [
        //     {email:"Rosa92.k@hotmail.fr",password:"yjzK0B"}
        //    ,{email:"abandadjohwilliam@gmail.com",password:"4ut18T"}
        //     ,{email:"d.maximilien@gmail.com",password:"nE5fNc"}
        //     ,{email:"eloundoupatricia@yahoo.fr",password:"xK4EKG"}
        //     ,{email:"fabrice.fehem@gmail.com",password:"1drlct"}
        //     ,{email:"fedjour@gmail.com",password:"NkJh44"}
        //     ,{email:"florent.zobel@gmail.com",password:"I4I9xh"}
        //     ,{email:"loreta.atomreprat@gmail.com",password:"0Ur8s2"}
        //     ,{email:"marina.djedouboum@gmail.com",password:"RYJLqX"}
            {email:"temitope.agunbiade@gmail.com",password:"yjzK0B"}
            ,{email:"Alexandra.dorsa@outlook.fr",password:"ML8-N6"}
            ,{email:"lg.lexyglam@gmail.com",password:"1BEG1-"}
            ,{email:"Ufitinemaf@gmail.com",password:"A729YH"}
            ,{email:"Hilarygkz@gmail.com",password:"ETC4B5"}
            ,{email:"Samba.svetlana@gmail.com",password:"X6RFQY"}
            ,{email:"jeannettecamelia@gmail.com",password:"MEIpAY"}
            // ,{email:"mvouyorick@gmail.com",password:"uWqLZi"}
            // ,{email:"thierry.pandzou@gmail.com",password:"aKljJE"}
            ];

            for(let v of person){
               this.sendPassword(v) 
            }
    }

    sendPassword(v){
     
            let body = `<p>&nbsp;</p>
<p>Bonjour chers &eacute;tudiant(e),</p>
<p>&nbsp;</p>
<p>Ton login pour acc&eacute;der &agrave; ton compte sur le site du <a href="https://www.eulogia-enseignement.fr">Eulogia&nbsp;</a>est :</p>
<h3><em><strong>${v.email}</strong></em></h3>
<p>Ton mot de passe pour acc&eacute;der &agrave; ton compte sur le site du <a href="https://www.eulogia-enseignement.fr/">Eulogia</a>&nbsp;est :</p>
<h3><em><strong>${v.password}</strong></em></h3>
<p>Votre espace est en cours d'&eacute;volution, un acc&egrave;s vous a &eacute;t&eacute; accord&eacute; pour vous permettre dans un premier temps d'acc&eacute;der aux cours qui seront partag&eacute;s par votre enseignant et qui seront uniquement disponibles en lecture.</p>
<p>Pour acc&eacute;der aux cours, aller sur la page <strong>ma formation</strong>.</p>
<p>Si vous avez des questions ou des remarques, partagez le nous par&nbsp;<a href="mailto:contact@eulogia-enseignement.fr">mail</a> <img src="https://wordhtml.com/tinymce/js/tinymce/plugins/emoticons/img/smiley-smile.gif" alt="smile" />.</p>
<p>&nbsp;</p>
<p>Cordialement,</p>
<p>L'Equipe Technique - Eulogia</p>
<p>`;
           return this.email(`Eulogia - COMPTE ETUDIANT`, body, v.email);

    }

    /**
     * 
     * @param body 
     * @param title 
     * @param toEmail 
     * @returns 
     */
    sendGlobalEmail(body: string, title: string, toEmail: string): Promise<any> {
        return this.email(title, body, toEmail);
    }


    /**
     * 
     * @param firstname 
     * @param email 
     */
    sendRegistrationAsker(firstname, email): Promise<any> {

        let body = `<p><em>Bonjour,</em></p>
        <p><em><em>${firstname} aimerait s'inscrire au cours du Eulogia. Veuillez valider sa demande de pr&eacute;inscription :</em></em></p>
        <p><a href="https://www.eulogia-enseignement.fr//students-registration">Demandes de pr&eacute;inscriptions</a>.</p>
        <p>&nbsp;</p>
        <p><em>A bient&ocirc;t </em></p>
        <p><em>L&rsquo;&eacute;quipe p&eacute;dagogique Eulogia</em></p>`;
        return this.email(`Eulogia - Nouvelle demande d'inscription`, body, email);
    }


        /**
         * 
         * @param courses 
         * @returns 
         */
        sendNotificationMailUpdatedCourse(courses:string): Promise<any> {

            let body = `<p><em>Bonjour,</em></p>
            <p><em><em>Un cours a &eacute;t&eacute; mis &agrave; jour&nbsp;:</em></em></p>
            <p><em><em>${courses}</em></p>
            <p>&nbsp;</p>
            <p><em>A bient&ocirc;t </em></p>
            <p><em>L&rsquo;&eacute;quipe Technique Eulogia</em></p>`;
            return this.email(`Eulogia - Mise à jour des cours`, body, "contact@eulogia-enseignement.fr");
        }

    /**
     * 
     * @param subject 
     * @param body 
     * @param toEmail 
     * @returns 
     */
    private email(subject: string, body: string, toEmail: string) {
        const mailCollection = collection(this.firestore, `mail`);
console.log(subject,body,toEmail);
        return addDoc(mailCollection, {
            to: [toEmail],
            message: {
                subject: subject,
                html: body,
            },
        })
    }
}



